$(function () {
    App.prototype.getCart();
    App.prototype.megaMenu();
    $('[data-toggle="tooltip"]').tooltip();

    $('[data-fancybox]').each(function () {
        $().fancybox({
            selector: '[data-fancybox="' + $(this).data('fancybox') + '"]',
            hash: false,
        });
    })

    document.addEventListener("wheel", function (event) {
        if (document.activeElement.type === "number") {
            document.activeElement.blur();
        }
    });

    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
    if (iOSSafari) {
        document.addEventListener("touchmove", function (event) {
            if (['number', 'text', 'tel', 'textarea'].indexOf(document.activeElement.type) !== -1) {
                document.activeElement.blur();
            }
        });

        $('body,html').css({
            height: "100%",
            overflow: "hidden",
            overflowY: "auto",
        });

        $('input[type="number"],input[type="text"],input[type="tel"],textarea').on('focus', function () {
            $(window).trigger('resize');
        });
        $('input[type="number"],input[type="text"],input[type="tel"],textarea').on('blur', function () {
            console.log(document.querySelector('body').offsetHeight);
            $(window).trigger('resize');
        });

        // const viewport = window.visualViewport;

        window.visualViewport.addEventListener("resize", function () {
            // $('body,html').css('height', viewport.height + 'px')
            console.log(document.querySelector('body').offsetHeight);
            $(window).trigger('resize');
        });
    }

});
